export default [
  {
    title: 'navigation.home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'navigation.warehouse',
    route: 'warehouse',
    icon: 'BoxIcon',
  },
  {
    title: 'navigation.product',
    route: 'product',
    icon: 'ShoppingCartIcon',
  },
  {
    title: 'navigation.order',
    route: 'order',
    icon: 'ShoppingBagIcon',
  },
  {
    title: 'navigation.region',
    route: 'region',
    icon: 'MapPinIcon',
  },
]
